import React from 'react';
import PropTypes from 'prop-types';
import { PageHeader, Button, Popover } from 'antd';

const style = {
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '12px 0',
  },
  button: {
    width: 120,
    margin: 5,
  },
};

const TableHeader = ({ children, onCreate, isWriteable }) => {
  return (
    <PageHeader
      title="Global changelog"
      style={style.container}
      extra={[
        <Popover
          placement="left"
          trigger="click"
          title="Visible"
          content={children}
          key="visible"
        >
          <Button type="primary" style={style.button}>
            Customize
          </Button>
        </Popover>,
        <div key="new" style={{ display: 'inline-block' }}>
          {isWriteable && (
            <Button
              type="primary"
              style={style.button}
              icon="plus"
              onClick={onCreate}
            >
              New
            </Button>
          )}
        </div>,
      ]}
    />
  );
};

TableHeader.propTypes = {
  onCreate: PropTypes.func.isRequired,
  isWriteable: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

TableHeader.defaultProps = {
  isWriteable: false,
};

export default TableHeader;
